import React, { useState, useEffect, useRef } from "react";
import { Modal, Tabs, Button, Spin, message } from "antd";
import axiosInstance from "../../service/AxiosInstance";
import userimg from "../../static/images/AI.png";
import "./login-nav.css";
import PerformanceBubbleChart from "./PerformanceBubbleChart";

const tabNames = [
  // "Performance vs Environment",
  "Executive Summary",
  "Sales Performance",
  "Competitor Analysis",
];

const CustomModal = ({
  isVisible,
  onClose,
  onTabDataFetch,
  response,
  loading,
  activeTab,
  setActiveTab,
  tabResults,
  setTabResults,
  currentStep,
  isValuationEdit,
  formattedData,
}) => {
  const modalRef = useRef(null); // Ref to access the modal element
  const [dragging, setDragging] = useState(false); // State to track if dragging
  const [position, setPosition] = useState({ x: 0, y: 0 }); // Position of the modal
  const dragStartPosition = useRef({ x: 0, y: 0 }); // Start position of drag
  const filteredTabNames =
    currentStep === 1 && isValuationEdit ? tabNames.slice(0, 1) : tabNames;

  const handleClose = () => {
    setTabResults({});
    setActiveTab("0");
    setPosition({ x: 0, y: 0 });
    onClose();
  };

  const handleTabChange = (key) => {
    if (!loading) {
      setActiveTab(key);
    }
  };

  useEffect(() => {
    if (isVisible && !tabResults[activeTab]) {
      onTabDataFetch(activeTab);
    }
  }, [isVisible, activeTab]);

  useEffect(() => {
    if (response && !loading) {
      // Save the fetched data for the current tab
      setTabResults((prev) => ({
        ...prev,
        [activeTab]: response,
      }));
    }
  }, [response, loading]);

  // Handle mouse down on header
  const handleMouseDown = (e) => {
    setDragging(true);
    dragStartPosition.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  // Handle mouse move
  const handleMouseMove = (e) => {
    if (dragging) {
      const newX = e.clientX - dragStartPosition.current.x;
      const newY = e.clientY - dragStartPosition.current.y;
      setPosition({ x: newX, y: newY });
    }
  };

  // Handle mouse up
  const handleMouseUp = () => {
    setDragging(false);
  };

  // Add and remove event listeners for mouse movement
  useEffect(() => {
    if (dragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging]);

  return (
    <Modal
      open={isVisible}
      footer={null}
      onCancel={handleClose}
      width={1100}
      className="AIModal"
      modalRender={(modal) => (
        <div
          ref={modalRef}
          style={{
            transform: `translate(${position.x}px, ${position.y}px)`,
            cursor: dragging ? "grabbing" : "default",
          }}
        >
          {modal}
        </div>
      )}
    >
      {/* Header Section */}
      <div
        className="AINav"
        style={{ cursor: "grab" }}
        onMouseDown={handleMouseDown}
      >
        <img src={userimg} alt="u_img" className="uimg" />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            marginLeft: "20px",
          }}
        >
          AI Advisor | Advanced Insights and Recommendations
        </h2>
      </div>

      {/* Tabs Section */}
      <div className="AINav2">
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          destroyInactiveTabPane
          tabBarStyle={{
            margin: 0,
            borderBottom: "none",
            padding: 0,
          }}
          renderTabBar={(props, DefaultTabBar) => (
            <DefaultTabBar
              {...props}
              style={{
                display: "flex",
                gap: "16px",
              }}
            />
          )}
        >
          {filteredTabNames.map((name, index) => (
            <Tabs.TabPane
              tab={
                <span
                  style={{
                    fontWeight:
                      activeTab === index.toString() ? "bold" : "normal",
                    fontSize: "16px",
                    padding: "8px 0",
                  }}
                >
                  {name}
                </span>
              }
              key={index.toString()}
              disabled={loading}
            />
          ))}
        </Tabs>
      </div>

      {/* Content Section */}
      <div className="AIResult">
        {loading ? (
          <div style={{ textAlign: "center", paddingTop: 100 }}>
            <Spin size="large" />
          </div>
        ) : (
          <iframe
            className="AIIframe"
            srcDoc={tabResults[activeTab] || "Data not available"}
          />
        )}
      </div>
    </Modal>
  );
};

export default CustomModal;
